export enum ProductType {
  FLIGHTS = "flights",
  LODGING = "lodging",
  CARS = "cars",
  PRICE_FREEZE = "price_freeze",
  PACKAGE = "package",
  ACTIVITIES = "activities",
  HOMES = "homes",
}
